export default __webpack_public_path__ + "static/device_lockup_large-2df808f5a0e406b563bb3fe1f707d646.png";